exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".button {\n  background-color: #4CAF50;\n  border: none;\n  color: white;\n  padding: 10px 24px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 15px;\n  margin: 10px;\n}\n\n.button .red {\n  background-color: red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/Quiz/styles.css
// module id = 1818
// module chunks = 0